import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useContext } from './Context'
import { LineItemContainer } from './LineItemContainer'

type OrderSummaryProps = { gross?: number; shippingFee?: number; taxAmount?: number; discount?: number; net?: number }

/** The five total rows. Takes the totals as props, else reads them from the order context. */
export const OrderSummary = (props: OrderSummaryProps) => {
  const { document } = useContext()
  const { gross, shippingFee, taxAmount, discount, net } = { ...document, ...props }
  return (
    <Row>
      <Col lg={{ span: 6, offset: 6 }}>
        <ul className="list-group list-group-flush">
          <LineItemContainer label="Subtotal" value={gross} />
          <LineItemContainer label="Shipping fee" value={shippingFee} />
          <LineItemContainer label="Tax amount" value={taxAmount} />
          <LineItemContainer label="Discount" value={discount} />
          <LineItemContainer label="Total" value={net} />
        </ul>
      </Col>
    </Row>
  )
}
